// @flow
import styled from 'styled-components';
import {
  textNormal,
  textBlack,
  textBold,
  textSemiBold,
  textBoldLoose,
} from './css';
import { Text0 } from './Text';

export const Text0Normal = styled(Text0)`
  ${textNormal};
`;

export const Text0Black = styled(Text0)`
  ${textBlack};
`;

export const Text0SemiBold = styled(Text0)`
  ${textSemiBold};
`;

export const Text0Bold = styled(Text0)`
  ${textBold};
`;

export const Text0BoldLoose = styled(Text0)`
  ${textBoldLoose};
`;
